export default __webpack_public_path__ + "static/media/logo_home.eb770d5c.png";